import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  ShipmentWaybillStatusHistory,
  ShipmentWaybillStatusHistoryMainInfo,
  ShipmentWaybillStatusHistoryStatuses,
} from '../../models/shipment-waybill-status-history.model';
import { ShipmentWaybillStatusHistoryService } from './shipment-waybill-status-history.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import {
  ShipmentWaybillStatusHistoryLoad,
  ShipmentWaybillStatusHistorySetInitialState,
} from './shipment-waybill-status-history.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentWaybillStatusHistoryStateModel {
  mainInfo: ShipmentWaybillStatusHistoryMainInfo;
  statusHistoryView: ShipmentWaybillStatusHistoryStatuses;
  loaded: boolean;
}

const initialState: ShipmentWaybillStatusHistoryStateModel = {
  mainInfo: null,
  statusHistoryView: null,
  loaded: false,
};

@State<ShipmentWaybillStatusHistoryStateModel>({
  name: 'shipmentWaybillStatusHistory',
  defaults: initialState,
})
@Injectable()
export class ShipmentWaybillStatusHistoryState {
  constructor(
    private shipmentWaybillStatusHistoryService: ShipmentWaybillStatusHistoryService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getState(state: ShipmentWaybillStatusHistoryStateModel): ShipmentWaybillStatusHistoryStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentWaybillStatusHistoryStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getStatusHistoryMainInfo(state: ShipmentWaybillStatusHistoryStateModel): ShipmentWaybillStatusHistoryMainInfo {
    return state.mainInfo;
  }

  @Selector()
  static getStatusHistoryView(state: ShipmentWaybillStatusHistoryStateModel): ShipmentWaybillStatusHistoryStatuses {
    return state.statusHistoryView;
  }

  @Action(ShipmentWaybillStatusHistoryLoad)
  getWaybillStatusHistory(
    ctx: StateContext<ShipmentWaybillStatusHistoryStateModel>,
    { payload }: ShipmentWaybillStatusHistoryLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentWaybillStatusHistoryService.getStatusHistoryData(payload).pipe(
      map((statusHistory: ShipmentWaybillStatusHistory) => {
        ctx.patchState({ ...statusHistory, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillStatusHistorySetInitialState)
  setInitialState(ctx: StateContext<ShipmentWaybillStatusHistoryStateModel>): void {
    ctx.setState(initialState);
  }
}
